/**
 * Web storage handlers.
 *
 * Wraps Web storage API methods to try/catch for preventing
 * fatal errors when storage is disabled in browser settings.
 *
 * Otherwise, it occurs "SecurityError: The operation is insecure."
 * exception.
 */

const debug = require('debug')('cw:web-storage.js');

export function sessionStorageGetItem(item) {
  if (typeof window !== 'undefined') {
    try {
      const { sessionStorage } = window;
      return sessionStorage.getItem(item) ?? null;
    } catch (error) {
      // Access denied - sessionStorage is disabled.
      debug('Could not get a sessionStorage item. Error: %O', error);
    }
  }
}

export function sessionStorageSetItem(item, data) {
  if (typeof window !== 'undefined') {
    try {
      const { sessionStorage } = window;
      sessionStorage.setItem(item, data);
    } catch (error) {
      // Access denied - sessionStorage is disabled.
      debug('Could not set a sessionStorage item. Error: %O', error);
    }
  }
}

export function sessionStorageRemoveItem(item) {
  try {
    const { sessionStorage } = window;
    sessionStorage.removeItem(item);
  } catch (error) {
    // Access denied - sessionStorage is disabled.
    debug('Could not remove a sessionStorage item. Error: %O', error);
  }
}

export function localStorageGetItem(item) {
  try {
    const { localStorage } = window;
    return localStorage.getItem(item) ?? null;
  } catch (error) {
    // Access denied - localStorage is disabled.
    debug('Could not get a localStorage item. Error: %O', error);
  }
}

export function localStorageSetItem(item, data) {
  try {
    const { localStorage } = window;
    localStorage.setItem(item, data);
  } catch (error) {
    // Access denied - localStorage is disabled.
    debug('Could not set a localStorage item. Error: %O', error);
  }
}

export function localStorageRemoveItem(item) {
  try {
    const { localStorage } = window;
    localStorage.removeItem(item);
  } catch (error) {
    // Access denied - localStorage is disabled.
    debug('Could not remove a localStorage item. Error: %O', error);
  }
}
